<template>
	<div class="message-title">
        <span class="username">{{ conversation.note ? conversation.note : conversation.object_name }}</span>
		<span class="username">{{ conversation.object_phone_number }}</span>
		<div v-if="conversation.object_type === 'personal'" style="float: right">
			<el-button type="default" size="mini" icon="fa fa-user" @click="handleContacntDetailClick" />
		</div>
		<div v-if="conversation.object_type === 'group'" style="float: right">
			<el-button type="default" size="mini" icon="fa fa-group" @click="handleGroupDetailClick" />
		</div>
	</div>
</template>

<script>
export default {
	name: "ChatTitle",

	props: {
		conversation: {
			type: Object,
			required: false,
			default: null
		}
	},

	data() {
		return {};
	},

	methods: {
		handleContacntDetailClick() {
			this.$emit("contact-detail-click");
		},

		handleGroupDetailClick() {
			this.$emit("group-detail-click");
		}
	}
};
</script>

<style lang="less" scoped>
.message-title {
	text-align: center;
	display: block;
	padding: 8px;
	color: #808080;
	background-color: #fcfcfc;
	border-top: 1px solid #d6d6d670;
	border-right: 1px solid #d6d6d670;
	border-left: 1px solid #d6d6d670;
	line-height: 30px;

	.username {
		font-size: 14px;
	}

	.customer-info {
		font-size: 14px;
	}
}
</style>
